module.exports = __webpack_public_path__ + "img/2.5b73a88c.png";